// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapFetching__container___nQi_0 {
    overflow: hidden;
    overflow-y: overlay;

    width: 70rem;
    height: 50rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}

.MapFetching__headerDescription___bWaUP {
    margin-bottom: 1.2rem;
}

.MapFetching__footer___LUDVv {
    display: flex;
    justify-content: flex-end;
}

.MapFetching__menu___ovEJD {
    width: 50%;
    padding: 0.5rem 0.75rem;
}

.MapFetching__leftMenu___TvFy6 {
    border-right: 0.1rem solid var(--color-bg-border);
}

.MapFetching__objectMenu___jTJQz {
    display: flex;
    flex-direction: row;
    gap: 1.2rem;
    align-items: flex-start;
}

.MapFetching__algorithmMenu___Z5p23 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.MapFetching__algorithmMenu___Z5p23 .Select {
    gap: 0.6rem;
    width: 100%;
}

.MapFetching__borderBottom___qpDta {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: 0.1rem solid var(--color-bg-border);
}

.MapFetching__textMargin___Y3Yth {
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;
}

.MapFetching__treeWidth___AoyUW {
    width: 13rem;
}

.MapFetching__marginForName___iLIWN {
    margin-top: 0.4rem;
    margin-left: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/MapFetchingModal/MapFetching.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;;IAEnB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,uEAAuE;AACvE;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".container {\n    overflow: hidden;\n    overflow-y: overlay;\n\n    width: 70rem;\n    height: 50rem;\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n}\n\n.headerDescription {\n    margin-bottom: 1.2rem;\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.menu {\n    width: 50%;\n    padding: 0.5rem 0.75rem;\n}\n\n.leftMenu {\n    border-right: 0.1rem solid var(--color-bg-border);\n}\n\n.objectMenu {\n    display: flex;\n    flex-direction: row;\n    gap: 1.2rem;\n    align-items: flex-start;\n}\n\n.algorithmMenu {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.algorithmMenu :global(.Select) {\n    gap: 0.6rem;\n    width: 100%;\n}\n\n.borderBottom {\n    margin-top: 0.5rem;\n    margin-bottom: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 0.1rem solid var(--color-bg-border);\n}\n\n.textMargin {\n    margin-top: 0.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.treeWidth {\n    width: 13rem;\n}\n\n.marginForName {\n    margin-top: 0.4rem;\n    margin-left: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MapFetching__container___nQi_0`,
	"headerDescription": `MapFetching__headerDescription___bWaUP`,
	"footer": `MapFetching__footer___LUDVv`,
	"menu": `MapFetching__menu___ovEJD`,
	"leftMenu": `MapFetching__leftMenu___TvFy6`,
	"objectMenu": `MapFetching__objectMenu___jTJQz`,
	"algorithmMenu": `MapFetching__algorithmMenu___Z5p23`,
	"borderBottom": `MapFetching__borderBottom___qpDta`,
	"textMargin": `MapFetching__textMargin___Y3Yth`,
	"treeWidth": `MapFetching__treeWidth___AoyUW`,
	"marginForName": `MapFetching__marginForName___iLIWN`
};
export default ___CSS_LOADER_EXPORT___;
